<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { TooltipContent as TooltipContentPrimitive, TooltipPortal, type TooltipContentProps } from 'reka-ui';
import { cn } from '@/lib/utils';

interface Props extends TooltipContentProps {
    class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<Props>(), {
    sideOffset: 6,
    side: 'top',
});
</script>

<template>
    <TooltipPortal>
        <TooltipContentPrimitive
            v-bind="{ ...props, class: undefined }"
            :class="
                cn('z-50 overflow-hidden rounded-md bg-gray-900 px-3 py-1.5 text-xs text-white shadow-md', props.class)
            "
        >
            <slot />
        </TooltipContentPrimitive>
    </TooltipPortal>
</template>

<style>
[data-reka-popper-content-wrapper] {
    transition: none !important;
}
</style>
